import { render, staticRenderFns } from "./indexOrderAD.vue?vue&type=template&id=7aca4925"
import script from "./indexOrderAD.vue?vue&type=script&lang=js"
export * from "./indexOrderAD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports